"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _enviro = _interopRequireDefault(require("enviro"));

var _I18n = _interopRequireDefault(require("I18n"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _injectScript2 = _interopRequireDefault(require("./utils/injectScript"));

var ENV = _enviro.default.getShort();

var qaSuffix = ENV === 'qa' ? 'qa' : '';
var loadLocalPopupInjector = window.localStorage && window.localStorage.getItem('LOCAL_FEEDBACK_UI') === 'true';
var PORTAL_ID_ATTR = 'data-hubspot-feedback-portal-id';
var CUSTOMER_PORTAL_ID_ATTR = 'data-hubspot-feedback-customer-portal-id';
var ENV_ATTR = 'data-hubspot-feedback-env';
var HUBSPOT_APP_ATTR = 'data-hubspot-feedback-hubspot-app';
var HUBSPOT_EMAIL_ATTR = 'data-hubspot-feedback-hubspot-email';
var ANALYTICS_SRC = "//js.hubspot" + qaSuffix + ".com/analytics/0/common.js";
var FEEDBACK_INJECTOR_SRC = loadLocalPopupInjector ? '//local.hsappstatic.net/feedback-web-renderer-ui/static/bundles/popupInjector.js' : "//js.hubspotfeedback" + qaSuffix + ".com/feedbackweb-new.js";
var hsq = window._hsq = window._hsq || [];
hsq.push(['setCookiePolicy', [{
  enabled: true,
  privacyPolicy: 2,
  privacyDefault: true
}]]);

var addOnClientReadyCallback = function addOnClientReadyCallback(onReady) {
  window.onHsFeedbackReady = window.onHsFeedbackReady || [];
  window.onHsFeedbackReady.push(onReady);
};

var inject = function inject(portalId, userInfoClient, onClientLoad) {
  (0, _injectScript2.default)(ANALYTICS_SRC);
  userInfoClient().then(function (_ref) {
    var _injectScript;

    var user = _ref.user,
        hubspotter = _ref.hubspotter;

    var _ref2 = user || hubspotter,
        email = _ref2.email;

    hsq.push(['identify', {
      email: email
    }]);
    (0, _injectScript2.default)(FEEDBACK_INJECTOR_SRC, (_injectScript = {}, (0, _defineProperty2.default)(_injectScript, PORTAL_ID_ATTR, portalId), (0, _defineProperty2.default)(_injectScript, CUSTOMER_PORTAL_ID_ATTR, _hubspot.default.get()), (0, _defineProperty2.default)(_injectScript, ENV_ATTR, ENV), (0, _defineProperty2.default)(_injectScript, HUBSPOT_APP_ATTR, true), (0, _defineProperty2.default)(_injectScript, HUBSPOT_EMAIL_ATTR, email), _injectScript));

    if (onClientLoad) {
      addOnClientReadyCallback(onClientLoad);
    }
  });
};

var FeedbackLoader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FeedbackLoader, _Component);

  function FeedbackLoader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FeedbackLoader);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FeedbackLoader).call(this, props));
    var delayMs = props.delayMs,
        onClientLoad = props.onClientLoad,
        portalId = props.portalId,
        userInfoClient = props.userInfoClient;
    if (window.hsFeedbackLoaded || !/^en/.test(_I18n.default.locale)) return (0, _possibleConstructorReturn2.default)(_this);
    hsq.push(['setPortalId', portalId]);
    setTimeout(function () {
      inject(portalId, userInfoClient, onClientLoad);
    }, delayMs);
    return _this;
  }

  (0, _createClass2.default)(FeedbackLoader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return FeedbackLoader;
}(_react.Component);

exports.default = FeedbackLoader;
FeedbackLoader.propTypes = {
  delayMs: _react.PropTypes.number,
  onClientLoad: _react.PropTypes.func,
  portalId: _react.PropTypes.number,
  userInfoClient: _react.PropTypes.func
};
FeedbackLoader.defaultProps = {
  delayMs: 0,
  portalId: ENV === 'prod' ? 53 : 100765651,
  userInfoClient: _userInfo.default
};
module.exports = exports.default;